export default __webpack_public_path__ + "static/industry-logistics-46134d39eaf7b2120578ab4fea472347.jpg";